import { Typography, IconButton } from '@mui/material';
import { useUser, useAuth } from '@clerk/clerk-react';
import { useState, useCallback } from 'react';
import { useConfirm } from 'material-ui-confirm';
import { PauseCircle, DeleteForever, FlipCameraAndroid, Send } from '@mui/icons-material';

import * as Api from '../Api';
import IntervalSelector from './IntervalSelector';
import { CardBody } from '../style';

function test(e) {
  e.preventDefault();

  // console.log(`Hi there, ${name}`);
}

function ManageCard({ flip, card }) {
  const { user } = useUser();
  const user_id = user.publicMetadata.stripe_id;
  const { getToken } = useAuth();
  const confirm = useConfirm();

  const [interval, setInterval] = useState(card.subscription ? card.subscription.interval : null);

  const handleUnsubscribe = (e) => {
    e.stopPropagation();
    confirm({ description: `This will pause card ${card.last4}.` })
      .then(() =>
        getToken().then((token) => {
          Api.call(token, 'DELETE', `subscription/${card.subscription.id}`).then((data) => {
            // TODO show spinner until completed response, handle error response
            // this one can probably just set local state (subscription etc) and dont have to reload page
            window.location.reload();
          });
        }),
      )
      .catch(() => console.log('Subscription pause cancelled.'));
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    confirm({ description: `This will delete card ${card.last4}.` })
      .then(() =>
        getToken().then((token) => {
          Api.call(token, 'DELETE', `card/${card.id}`).then((data) => {
            // TODO show spinner until completed response, handle error response
            // would be nice to just pop card from the list rather than reloading like this
            window.location.reload();
          });
        }),
      )
      .catch(() => console.log('Card deletion cancelled.'));
  };

  const submit = async (e) => {
    e.stopPropagation();
    // TODO change messaging here
    // something along the lines of 'this will re-subscribe card' or 'this will change sub from x to y'
    confirm({ description: `This will subscribe card ${card.last4}.` })
      .then(() => {
        getToken().then((token) => {
          if (card.subscription) {
            try {
              // TODO these API calls are used again in like Status for example, abstract these better
              Api.call(token, 'PUT', `subscription/${card.subscription.id}?interval=${interval}`);
              // TODO maybe wait a couple seconds here and show a nice loading icon?
              window.location.reload();
            } catch (err) {
              // TODO
            }
          } else {
            try {
              Api.call(
                token,
                'POST',
                `subscription?user_id=${user_id}&pm_id=${card.id}&interval=${interval}`,
              );
              // TODO maybe wait a couple seconds here and show a nice loading icon?
              window.location.reload();
            } catch (err) {
              // TODO
            }
          }
        });
      })
      .catch(() => console.log('Subscription cancelled.'));
  };

  return (
    <CardBody onClick={() => flip((prev) => !prev)}>
      {/* TODO also have a card identifier on this side IE AMEX 0004 0424 */}
      {/* TODO maybe have a toggle switch to handle subscription instead */}
      {/* TODO i dont think this label works? */}
      {/* {card.subscription && <Typography>{card.subscription.interval}</Typography>} */}
      {/* {card.subscription && <Typography>Renews: {card.subscription.renews}</Typography>} */}
      {/* TODO select an interval for this subscribe button */}
      {/* {!card.subscription && <Button onClick={() => subscribe(user_id, card.id)}>Subscribe</Button>} */}

      <div
        style={{
          display: 'flex',
          width: '100%',
          flexDirection: 'horizontal',
          justifyContent: 'space-between',
        }}
      >
        <IconButton disabled={true}>
          <FlipCameraAndroid />
        </IconButton>
        {card.subscription ? (
          <IconButton onClick={handleUnsubscribe}>
            <PauseCircle />
          </IconButton>
        ) : (
          <IconButton onClick={handleDelete}>
            <DeleteForever />
          </IconButton>
        )}
      </div>

      {/* TODO give this a separate background color so its obvious where its clickable */}
      <IntervalSelector interval={interval} setInterval={setInterval} />

      <IconButton disabled={interval == card.subscription?.interval} onClick={submit}>
        <Send>
          <h3>hello</h3>
        </Send>
      </IconButton>

      {/* TODO have a submit button, that will either update this sub or create a new one 
      depending on if this card has a sub or not. button text changes too */}
    </CardBody>
  );
}

export default ManageCard;
